/**
 * Spinner — SVG animated loading indicator.
 *
 * Props:
 *   size   'sm' | 'md' | 'lg'  (default: 'md')
 *   label  string               (default: 'Loading…') — accessible aria-label
 */
export default function Spinner({ size = 'md', label = 'Loading…' }) {
  const px = { sm: 18, md: 28, lg: 44 }[size] ?? 28
  const sw = { sm: 2.5, md: 3, lg: 3.5 }[size] ?? 3

  return (
    <span className="spinner" role="status" aria-label={label}>
      <svg width={px} height={px} viewBox="0 0 24 24" fill="none">
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="var(--border-color)"
          strokeWidth={sw}
        />
        <path
          d="M12 2a10 10 0 0 1 10 10"
          stroke="var(--primary-color)"
          strokeWidth={sw}
          strokeLinecap="round"
        />
      </svg>
    </span>
  )
}
